import styled from 'styled-components';

export const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const CenteredHorizontally = styled.div`
  display: flex;
  justify-content: center;
`;

export const Scrollable = styled.div`
  height: 100%;
  overflow-y: auto;
`;
